export const toLocaleStringSupportsOptions = (): boolean =>
  !!(
    typeof Intl === 'object' &&
    Intl &&
    typeof Intl.NumberFormat === 'function'
  )
